import React, { useState } from 'react';
import styles from './index.module.scss';
import HeadContainer from '../../../../common/head-container';

const WelcomeFormScreen = ({
  setScreenNumber,
  handleNextScreen,
  handleSkipScreen
}) => {
  const [captchaPassed] = useState(true);
  const siteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

  return (
    <div
      className={styles.container}
      style={{ backgroundImage: 'url("/images/26ua-lm-lfc-auth/bg.png")' }}
    >
      <div className={styles.headContainer}>
        <HeadContainer setScreenNumber={setScreenNumber} telegramOnly />
      </div>
      <div className={styles.content}>
        <p className={styles.title}>
          Вітаємо у діджитальному світі компанії Філіп Морріс!
        </p>
        <p className={styles.description}>
          Реєструйся на платформі, проходь коротке опитування та отримуй
          поповнення мобільного рахунку на 30 гривень за витрачений час.
        </p>
        <div className={styles.buttonContainer}>
          <button
            className={styles.nextButton}
            onClick={handleNextScreen}
            disabled={siteKey ? !captchaPassed : false}
          >
            <img
              className={styles.buttonGlow}
              src="/images/26ua-lm-lfc-auth/button-glow.svg"
              alt=""
            />
            <span>Далі</span>
          </button>
          <button className={styles.skipButton} onClick={handleSkipScreen}>
            Пропустити
          </button>
        </div>
      </div>
      <div className={styles.footer}>
        Натискаючи «ДалI» ти робиш запит на отримання інформації про продукцію
        компанії Філіп Морріс засобами дистанційного зв'язку відповідно до
        частини 2 статті 15 Закону «Про захист прав споживачів» та підтверджуєш,
        що Є СПОЖИВАЧЕМ ТЮТЮНОВИХ ВИРОБІВ ТА/АБО КОРИСТУВАЧЕМ ПРИСТРОЇВ ДЛЯ
        СПОЖИВАННЯ ТЮТЮНОВИХ ВИРОБІВ БЕЗ ЇХ ЗГОРЯННЯ“.
      </div>
    </div>
  );
};

export default WelcomeFormScreen;
